import {createSlice} from '@reduxjs/toolkit';
import {sendFeedback} from '../actions/feedback';

const initialState = {
    success: false,
    isLoading: false,
    hasError: false,
    errorMessage: '',
};

const feedbackSlice = createSlice({
    name: 'feedback',
    initialState,
    reducers: {
        resetFeedback: () => initialState,
    },
    extraReducers(builder) {
        builder
            .addCase(sendFeedback.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(sendFeedback.fulfilled, (state, action) => {
                state.isLoading = false;
                state.success = true;
            })
            .addCase(sendFeedback.rejected, (state, action) => {
                state.isLoading = false;
                state.success = false;
                state.hasError = true;
                state.errorMessage = action.payload.errorMessage;
            });
    },
});

export const {resetFeedback} = feedbackSlice.actions;
export default feedbackSlice.reducer;
